<form class="drop-padding" [formGroup]="createForm" (ngSubmit)="create()">
  <app-eshop-selector [control]="eshopControl"></app-eshop-selector>
  <mat-form-field appearance="outline">
    <mat-label>Ссылка</mat-label>
    <textarea matInput formControlName="link"></textarea>
  </mat-form-field>
  <button mat-flat-button color="primary">Создать</button>
</form>
